export const isShowNewIssueModal = state => state.showNewIssueModal;
